module.exports = __webpack_public_path__ + "img/product3.20f94e27.png";